import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";

export interface ICategoryCar {
  id: number
  code: string
  title: string
  status: number
  image: string
  carLineId: number
  carLineTitle: string
  typeVehicleId: number
  typeVehicleTitle: string
}

export interface ICategoryCarEdit {
  id: number
  title: string
  code: string
  image: string
}

export const getListCategoryCar = async (
  limit?: number, pageNumber?: number, carLineId?: number, typeVehicleId?: number,
  search?: string
) => {
  const path = "categoryCar/listCategoryCar"
  const params = {
    limit, pageNumber, carLineId, typeVehicleId,
    search
  }
  const result: ResponseSuccessTotal<ICategoryCar[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin thương hiệu xe
export const getInfoCategoryCar = async (
  id: number) => {
  const path = "categoryCar/infoCategoryCar"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ICategoryCar> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thêm mới thương hiệu xe
export const addCategoryCar = async (
  code: string, title: string, image: File | null,
  carLineId: number, typeVehicleId: number,
) => {
  const url = `categoryCar/addCategoryCar`;
  const params = {
    code, title, image,
    carLineId, typeVehicleId,
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

//Chỉnh sửa thương hiệu xe
export const editCategoryCar = async (
  id: number, code: string, title: string, carLineId: number,
  image: File | null, typeVehicleId: number,
) => {
  const url = `categoryCar/editCategoryCar`;
  const params = {
    id, code, title, carLineId,
    image, typeVehicleId,
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

//Xóa thương hiệu xe
export const deleteCategoryCar = async (
  id: number[]
) => {
  const url = `categoryCar/deleteCategoryCar`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

// Cập nhật trạng thái thương hiệu

export const updateActiveCategoryCar = async (
  id: number) => {
  const path = "categoryCar/activeCategoryCar"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};
